import { useCallback, useRef, useState } from 'react';
import { notifications } from '@mantine/notifications';
import type { OrderView, TenbisStatusAction } from 'shared-models/browser';
import { posTenbisService } from '../../../../../services/pos-tenbis/pos-tenbis.service';

type Params = {
  tenantId: string;
  employeeSession: string | null;
  orderId: number;
};

// One in-flight action per order; the local state patches arrive through the POS SSE deltas.
export function useTenbisOrderActions({ tenantId, employeeSession, orderId }: Params) {
  const [inFlight, setInFlight] = useState<TenbisStatusAction | null>(null);
  const inFlightRef = useRef(false);

  const apply = useCallback(async (action: TenbisStatusAction): Promise<OrderView | null> => {
    if (!employeeSession || inFlightRef.current) {
      return null;
    }
    inFlightRef.current = true;
    setInFlight(action);
    try {
      return await posTenbisService.applyStatus(tenantId, employeeSession, orderId, { action });
    } catch (error: unknown) {
      notifications.show({
        color: 'red',
        title: 'תן ביס',
        message: error instanceof Error ? error.message : 'עדכון ההזמנה בתן ביס נכשל',
        autoClose: 4000,
      });
      return null;
    } finally {
      inFlightRef.current = false;
      setInFlight(null);
    }
  }, [employeeSession, orderId, tenantId]);

  return { inFlight, apply };
}
